<template>
  <div class="mobileSearch">
    <mbHeader title="" style="background-color: #f6f6f6">
      <div class="left" style="height: 26px;" @click="$router.go(-1)">
        <img src="../../assets/img/arrow_left_wecom.png" alt="">
      </div>
      <div class="search-bar" style="padding-left: 10px">
        <input
          ref="searchInputRef"
          type="text"
          :placeholder="$t('search')"
          v-model="searchTerm"
          @keypress.enter="searchProduct"
        >
        <div class="hoverBtn" @click="searchProduct">
          <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }"/>
        </div>
      </div>
    </mbHeader>

    <div class="History">
      <div class="titleH">
        History
        <i class="el-icon-delete" @click="removeAllHistory"></i>
      </div>
      <ul class="HistoryList" v-if="afmSearch.length>0">
        <li v-for="(item,index) in afmSearch" @click="searchProductClick(item)">
          {{ item }}
          <span class="history-list-li-close" @click.stop="removeHistoryItem(item)">
            <i class="el-icon-error"></i>
          </span>
        </li>
      </ul>
      <div class="noData" v-else>No Data</div>
    </div>

    <div class="History Trending">
      <div class="titleH">Trending</div>
      <ul class="HistoryList" v-if="afmSearch.length>0">
        <li v-for="(item,index) in afmSearch" @click="searchProductClick(item)">{{ item }}</li>
      </ul>
      <div class="noData" v-else>No Data</div>
    </div>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import Utils from "../../assets/js/util";
const AFM_SEARCH_KEY = 'afmSearch'

export default {
  name: "mobileSearch",
  components: { mbHeader },
  data() {
    return {
      searchTerm: '',
      afmSearch: []
    }
  },
  activated() {
    this.afmSearch = []
    // console.log(localStorage.getItem(AFM_SEARCH_KEY));
    if(localStorage.getItem(AFM_SEARCH_KEY)) {
      this.afmSearch = localStorage.getItem(AFM_SEARCH_KEY).split(',')
    }
    // console.log(this.afmSearch);
    this.searchInputFocus()
  },
  methods: {
    searchProduct() {
      if(this.afmSearch.indexOf(this.searchTerm)==-1){
        this.afmSearch.push(this.searchTerm)
      }

      localStorage.setItem(AFM_SEARCH_KEY,this.afmSearch.join(','))
      Utils.$emit("clearList");
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewSearch(this.searchTerm, 'Name');
      }, 300);
    },

    searchProductClick(item) {
      Utils.$emit("clearList");
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewSearch(item, 'Name');
      }, 300);
    },

    searchInputFocus() {
      const searchInputRef = this.$refs.searchInputRef
      searchInputRef && searchInputRef.focus()
    },

    removeAllHistory() {
      this.$confirm('Clear all search history?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'CALCEL',
        type: 'warning',
        center: true
      }).then(() => {
        this.afmSearch = []
        localStorage.removeItem(AFM_SEARCH_KEY)
      }).catch(() => {});
    },

    removeHistoryItem(item) {
      const idx = this.afmSearch.indexOf(item)
      this.afmSearch.splice(idx, 1)
      localStorage.setItem(AFM_SEARCH_KEY, this.afmSearch.join(','))
    }
  }
}
</script>

<style scoped lang="less">
.mobileSearch {
  padding: 66px 26px 26px;
  min-height: 100vh;
  background-color: #f6f6f6;
  .History{
    margin-bottom: 20px;
    .titleH{
      font-size: 13px;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .HistoryList{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      &:after{
        content: '';
        width: calc(33.3% - 16px);
        visibility: hidden;
      }
      li{
        width: calc(33.3% - 16px);
        padding: 6px 18px 5px;
        background-color: #FFFFFF;
        border-radius: 20px;
        text-align: center;
        font-size: 13px;
        color: #8ba39e;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .history-list-li-close {
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
        }
      }
    }
    .noData{
      text-align: center;
      font-size: 13px;
      color: #8ba39e;
      margin-bottom: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileSearch.vue